import React from "react";

function RecentActivityCard({ data }) {

    return (
        <div className="card">
            <div className="card-header py-3">
                <h6 className="mb-0 fw-bold ">Recent Activity</h6>
            </div>
            <div className="card-body">
                {data?.recentActivity?.map((rec, idx) => (
                    <div key={idx} className={`timeline-item ${rec?.type === "Punch In" ? "ti-success" : "ti-danger"} border-bottom ms-2`}>
                        <div className="d-flex">
                            <span className="avatar d-flex justify-content-center align-items-center rounded-circle light-success-bg">{rec?.type === "Punch In" ? "PI" : "PO"}</span>
                            <div className="flex-fill ms-3">
                                <div className="mb-1"><strong>{rec?.type}</strong></div>
                                <span className="d-flex text-muted align-items-center"><i className="icofont-ui-clock me-1"></i> {rec?.time}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}


export default RecentActivityCard;